// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { nonStockedItemsStyles } from "@steiner/App/Widgets/Cart/NonStockedItems";
import { addToCartButtonStyles } from "@steiner/XDL/PreStyle/button";
import { color, hideElementOnPrint, xScreen } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

nonStockedItemsStyles.container = {
    css: css`
        border: 1px solid ${color("common.border")};
        ${hideElementOnPrint}
    `,
};

nonStockedItemsStyles.headerWrapper = {
    css: css`
        background: ${color("common.ui8")};
        padding: 12px;
    `,
};

nonStockedItemsStyles.headerText = {
    variant: "h3",
    color: "common.ui1",
    css: css`
        margin: 0;
    `,
};

nonStockedItemsStyles.contentWrapper = {
    css: css`
        padding: 12px;
    `,
};

nonStockedItemsStyles.contentTitle = {
    variant: "h4",
};

nonStockedItemsStyles.contentDescription = {
    forwardAs: "p",
    size: 14,
    lineHeight: "22px",
    css: css`
        margin-bottom: 16px;
    `,
};

nonStockedItemsStyles.partNumberTextField = {
    cssOverrides: {
        formField: css`
            margin-bottom: 16px;
        `,
    },
};

nonStockedItemsStyles.descriptionTextArea = {
    cssOverrides: {
        formField: css`
            margin-bottom: 16px;
        `,
        inputSelect: css`
            min-height: 99px;
        `,
    },
};

nonStockedItemsStyles.actionsWrapper = {
    css: css`
        display: flex;
        gap: 12px;
        justify-content: flex-end;
    `,
};

nonStockedItemsStyles.addToCartButton = {
    ...addToCartButtonStyles,
    sizeVariant: "large",
    typographyProps: {
        ...addToCartButtonStyles.typographyProps,
    },
    css: css`
        ${addToCartButtonStyles.css}
        width: 100%;
        max-width: 230px;

        ${xScreen("lte", "xs")} {
            max-width: 100%;
        }
    `,
};
